import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=1a5124fa&scoped=true"
import script from "./ActionCard.vue?vue&type=script&lang=js"
export * from "./ActionCard.vue?vue&type=script&lang=js"
import style0 from "./ActionCard.vue?vue&type=style&index=0&id=1a5124fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5124fa",
  null
  
)

export default component.exports